import { AiseaApiFactory } from "@/api/aisea/apiFactory";

const operationMasterApi = AiseaApiFactory.get("operationMaster");

// 運航管理マスタ（港・貨物種類）の取得サービス。
// PORT_HIERARCHY_PICKER / CARGO_PICKER の ID→名称解決に使用する。
class OperationMasterService {
  /**
   * 港マスタ（3階層）を配列で取得する。
   * @returns {Promise<Array>} [{ id, name, districts: [{ id, name, berths: [{ id, name }] }] }]
   */
  async getPorts() {
    const res = await operationMasterApi.ports();
    const payload = res && res.data;
    if (Array.isArray(payload)) return payload;
    return (payload && payload.ports) || [];
  }

  /**
   * 貨物種類マスタを配列で取得する。
   * @returns {Promise<Array>} [{ id, name, units, cargo_category_id, disabled }]
   */
  async getCargoTypes() {
    const res = await operationMasterApi.cargoTypes();
    const payload = res && res.data;
    if (Array.isArray(payload)) return payload;
    return (payload && payload.cargo_types) || [];
  }
}

export default new OperationMasterService();
